import * as React from "react";
const SvgDocs = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", fill: "none", viewBox: "0 0 20 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 1.5, d: "M.75 3A2.25 2.25 0 0 0 3 5.25h14.25M.75 3A2.25 2.25 0 0 1 3 .75h13.25a1 1 0 0 1 1 1v3.5M.75 3v18A2.25 2.25 0 0 0 3 23.25h15.25a1 1 0 0 0 1-1v-16a1 1 0 0 0-1-1h-1M13 11.75H6" }));
export {
  SvgDocs as default
};
//# sourceMappingURL=docs.js.map
